import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel" className="grid-bg min-h-[85vh] flex items-center justify-center px-4">
      <div className="brutal-card max-w-md text-center" style={{borderColor:'#FF0055'}}>
        <div className="font-bebas text-5xl tracking-tighter">Cancelou, cria?</div>
        <p className="mt-3 text-white/60 font-manrope">Tudo bem, tá aqui quando quiser voltar.</p>
        <Link to="/dashboard" className="brutal-btn mt-8 w-full">Voltar</Link>
      </div>
    </div>
  );
}
